export default {
  YourUsername: 'Your Username',
  YourPassword: 'Your Password',
  Login: 'Login',
  LoginGitHub: 'Sign in with GitHub',
};
